var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolbsIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_24",
    "data-name": "Component 1 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.451,
    height: 23.451,
    viewBox: "0 0 23.451 23.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M6.079,22.874a28.114,28.114,0,0,0,5.65.576,28.12,28.12,0,0,0,5.65-.576,7.055,7.055,0,0,0,5.5-5.5,27.975,27.975,0,0,0,0-11.3,7.054,7.054,0,0,0-5.5-5.5,27.945,27.945,0,0,0-11.3,0,7.055,7.055,0,0,0-5.5,5.5,27.975,27.975,0,0,0,0,11.3,7.056,7.056,0,0,0,5.5,5.5M1.893,6.345A5.714,5.714,0,0,1,6.348,1.89a26.613,26.613,0,0,1,10.762,0,5.713,5.713,0,0,1,4.455,4.455,26.622,26.622,0,0,1,0,10.762,5.715,5.715,0,0,1-4.455,4.455,26.676,26.676,0,0,1-10.762,0,5.716,5.716,0,0,1-4.455-4.455,26.649,26.649,0,0,1,0-10.762",
    transform: "translate(-0.003 0)",
    fill: "#4e428d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M6.513,18.393a.667.667,0,0,0,.474-.2l4.285-4.285,2.659,2.659a.67.67,0,0,0,.947,0l5.428-5.428a.67.67,0,1,0-.948-.947L14.4,15.149,11.746,12.49a.671.671,0,0,0-.948,0L6.04,17.25a.67.67,0,0,0,.474,1.144",
    transform: "translate(-1.446 -2.47)",
    fill: "#4e428d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolbsIcon5);
export default __webpack_public_path__ + "static/media/evolbs_icon5.6e235664.svg";
export { ForwardRef as ReactComponent };